import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class MakeUpReferenceService extends BaseReferenceService {
  constructor() {
    super('MakeUpReference');
  }
}
